export default {
  SET_REDIRECT_URL: 'SET_REDIRECT_URL',
  RECEIVE_USER: 'RECEIVE_USER',
  SET_USER_PASSWORD: 'SET_USER_PASSWORD',
  RECEIVE_EXPENSES: 'RECEIVE_EXPENSES',
  RECEIVE_ACCOUNTS: 'RECEIVE_ACCOUNTS',
  DELETED_EXPENSE: 'DELETED_EXPENSE',
  DELETED_ACCOUNT: 'DELETED_ACCOUNT',
  REMOVE_MONTHS: 'REMOVE_MONTHS'
};



// WEBPACK FOOTER //
// ./src/actions/action-types.ts